'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.util.SessionStorageService', []);

_module.factory('SessionStorageService', SessionStorageService);

exports.default = _module;


function SessionStorageService() {

    // Test support of sessionStotage
    var SS_TEST_KEY = 'Ss-test-key';
    var isSessionStorageSupported = (typeof sessionStorage === 'undefined' ? 'undefined' : (0, _typeof3.default)(sessionStorage)) === 'object';

    try {
        sessionStorage.setItem(SS_TEST_KEY, 'Ss-test-data');
        sessionStorage.removeItem(SS_TEST_KEY);
    } catch (e) {
        isSessionStorageSupported = false;

        // If we get error that we exceeded storage's quota
        // but storage is still empty we are in browser private mode
        if (e.code === DOMException.QUOTA_EXCEEDED_ERR && sessionStorage.length === 0) {
            // Browser private mode
        } else {
            throw e;
        }
    }

    var service = {
        getData: getData,
        setData: setData,
        removeData: removeData,
        clearData: clearData
    };

    return service;

    /**
     * Get saved data from sessionStorage.
     *
     * @param {String} key
     * @returns {(string|null)} data or null
     */
    function getData(key) {
        if (isSessionStorageSupported) {
            var data = JSON.parse(sessionStorage.getItem(key));
            return data;
        }
        return undefined;
    }

    /**
     * Save data to sessionStorage.
     *
     * @param {String} key
     * @param {String} data
     */
    function setData(key, data) {
        if (isSessionStorageSupported) {
            sessionStorage.setItem(key, (0, _stringify2.default)(data));
        }
    }

    /**
     * Remove saved data from sessionStorage.
     *
     * @param {String} key
     */
    function removeData(key) {
        if (isSessionStorageSupported) {
            sessionStorage.removeItem(key);
        }
    }

    /**
     * Remove all saved data from sessionStorage.
     *
     */
    function clearData() {
        if (isSessionStorageSupported) {
            sessionStorage.clear();
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/util/session-storage.service.js
// module id = 831
// module chunks = 0